// ─── Utenti staff: il contratto della schermata Impostazioni → Utenti ────────
import { z } from 'zod';
import { permessoSchema, ruoloSchema } from './permessi.js';
import { emailSchema } from './auth.js';
export const utenteStaffSchema = z.object({
    id: z.uuid(),
    email: z.string(),
    fullName: z.string().nullable(),
    role: ruoloSchema,
    active: z.boolean(),
    mustChangePassword: z.boolean(),
    /**
     * `false` finché non ha creato il suo accesso da `/auth/register`.
     * ⚖️ Si dice «ha una password», non si manda l'hash: un hash in una risposta
     * è un hash che finisce nel registro del browser e nelle cache di mezzo.
     */
    hasPassword: z.boolean(),
    lastLoginAt: z.string().nullable(),
    /** Le righe di `staff_permissions`: le SPUNTE, non i permessi effettivi. */
    permissions: z.array(permessoSchema),
});
export const elencoUtentiStaffSchema = z.object({ items: z.array(utenteStaffSchema) });
export const creaUtenteStaffSchema = z.object({
    email: emailSchema,
    fullName: z.string().trim().min(1, 'Serve il nome').max(200),
    role: ruoloSchema,
    permissions: z.array(permessoSchema).default([]),
});
export const modificaUtenteStaffSchema = z
    .object({
    fullName: z.string().trim().min(1).max(200).optional(),
    role: ruoloSchema.optional(),
    active: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Non c’è niente da cambiare' });
/**
 * Le spunte, tutte insieme.
 *
 * ⚖️ Si manda l'elenco INTERO, non una differenza. Una differenza («aggiungi
 * questo, togli quello») calcolata su una schermata aperta da dieci minuti
 * riscrive scelte che nel frattempo ha fatto qualcun altro; un elenco intero
 * dice cosa dev'essere vero adesso.
 */
export const spunteSchema = z.object({ permissions: z.array(permessoSchema) });
//# sourceMappingURL=utenti.js.map